<template>
  <div
    :data-cnstrc-item-id="cnstrcItemId"
    :data-cnstrc-item-name="cnstrcItemName"
    :data-cnstrc-item-price="cnstrcItemPrice"
    :data-cnstrc-item-variation-id="cnstrcItemVariationId"
    data-cnstrc-product-detail
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useFetchPickers } from '~/scopes/product-core/composables/useFetch/useFetchPickers/useFetchPickers'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'

const { data: productResponse } = useFetchProduct()
const { selectedOffer } = useFetchPickers()

const cnstrcItemId = computed(() => productResponse.value?.productId ?? '')
const cnstrcItemName = computed(
  () => productResponse.value?.titles?.default ?? '',
)
const cnstrcItemVariationId = computed(() => selectedOffer.value?.offerId ?? '')
const cnstrcItemPrice = computed(() => selectedOffer.value?.price?.amount ?? '')
</script>
